import { useQuery } from 'react-query';
import { useBuildingIdAtom } from 'stores/building-id-atom';

import { axiosInstance } from '../axiosInstance';

export interface AmenityData {
  availableEndTime: number;
  availableStartTime: number;
  capacity: number;
  id: number;
  image: string;
  multiDayBooking: boolean;
  name: string;
  timeInterval: number;
}

const getAmenitiesKey = (buildingId: number | null) => ['amenities', buildingId];

const getAmenities = async (buildingId: number | null) => {
  const { data } = await axiosInstance.get<AmenityData[]>(`/amenity/${buildingId}`);
  // Note: Filter out amenities that are multiDayBooking
  return data.filter((amenity) => !amenity.multiDayBooking);
};

export const useGetAmenities = () => {
  const [buildingId] = useBuildingIdAtom();

  return useQuery({
    enabled: !!buildingId,
    queryKey: getAmenitiesKey(buildingId),
    queryFn: () => getAmenities(buildingId),
  });
};
